import styled from "styled-components";
import BranchInfo from "features/owner/components/branch/BranchInfo";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import BranchListView from "features/owner/components/branch/BranchListView";
import { hw, scrollbar } from "features/homework/homeworkUi";

const Branch = () =>{
    const [clickedBranch, setClickedBranch] = useState<string>("");
    return(
        <Page>
            <PageHeader>
                <Title>지점관리</Title>
                <Desc>지점을 조회하고 등록·수정합니다.</Desc>
            </PageHeader>
            <Body>
                <Outlet/>
                <BranchInfo branch_id={clickedBranch}/>
                <BranchListView clickedItem={clickedBranch} setClickedItem={setClickedBranch} />
            </Body>
        </Page>
    )
}

const Page = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 20px 24px;
`;

const PageHeader = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px 16px;
    flex-shrink: 0;
`;

const Title = styled.h1`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: ${hw.text};
`;

const Desc = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${hw.textMuted};
`;

const Body = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(300px, 360px);
    gap: 16px;
    flex: 1;
    min-height: 0;

    @media (max-width: 960px) {
        grid-template-columns: minmax(0, 1fr);
        overflow: auto;
        ${scrollbar}
    }
`;

export default Branch;
